export enum InvestorState {
  DRAFT = 'draft',
  INVITED = 'invited',
  COSIGNING = 'cosigning',
  SIGNED = 'signed',
  WAITING = 'waiting',
  ACCEPTED = 'accepted',
  INACTIVE = 'inactive',
  PROCESSING_COUNTERSIGN = 'processing_countersign',
}

export const isInvestorAtLeastSigned = (state: InvestorState) =>
  state === InvestorState.SIGNED ||
  state === InvestorState.WAITING ||
  state === InvestorState.ACCEPTED;
